export const roleItems = [
    {
        id: 1,
        menu_id: 5,
        email_allowed: [
            'yoshua@paideia.id',
            'michael@paideia.id'
        ]
    },
]